var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it"},[_c('backgroundcarrerpage',{attrs:{"career":_vm.career_data}}),_c('navbar'),_c('work-page',{attrs:{"career":_vm.career_data}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }